<div class="input-with-spinner-container"
  [style.--spinner-position]="spinnerPosition"
  [style.--spinner-color]="spinnerColor"
>
  <input type="text" name="{{name}}" class="text-input" [ngModel]="value" (ngModelChange)="valueChange.emit($event)" [readonly]="readonly || showSpinner" #inputWithSpinner="ngModel" >
  <mat-progress-spinner [hidden]="!showSpinner"  mode="indeterminate" [diameter]="spinnerDiameter" ></mat-progress-spinner>
</div>
